import DueDiligenceItemEditModalContainer from './containers/DueDiligenceItemEditModalContainer'

export default DueDiligenceItemEditModalContainer
